import React, { useEffect, useState } from "react";
import { fetchAssistants } from "../../services/assistant";

import Loader from "../../components/Loader";
import CalendarComponent from "../../components/CalendarComponent";
import Calls from "./dashboardpages/Calls";
import Messages from "./dashboardpages/Messages";
import AssistantDropDown from "./dashboardpages/AssistantDropDown";

const Dashboard = () => {
  const [assistants, setAssistants] = useState([]);
  const [selectedAssistant, setSelectedAssistant] = useState("");

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleAssistantChange = async (event) => {
    let assistant_id = event.target.value;
    if (!assistant_id) {
      return;
    }

    setSelectedAssistant(assistant_id);
  };

  const fetchAssistantsFromApi = async () => {
    try {
      const responseData = await fetchAssistants();
      if (responseData.status === "success") setAssistants(responseData.data);
    } catch (error) {
      setError(error);
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      const currentDate = new Date();
      const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

      setStartDate(startDate);
      setEndDate(endDate);

      try {
        await Promise.all([fetchAssistantsFromApi()]);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllData();
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  if (error) {
    return <div>Error: {error?.message}</div>;
  }

  return (
    <div className="w-full px-6">
      <div className="">
        <div className="flex flex-col w-full mt-5">
          <div className="flex flex-row pb-8">
            <CalendarComponent startDate={startDate} endDate={endDate} handleStartDateChange={setStartDate} handleEndDateChange={setEndDate} />

            <div className="w-80">
              <label className="block mb-2 ">Assistant</label>
              <div>{assistants && <AssistantDropDown selectedAssistant={selectedAssistant} assistants={assistants} handleAssistantChange={handleAssistantChange} />}</div>
            </div>
          </div>
        </div>
        <div className="py-3 text-left text-lg">Calls</div>
        <Calls startDate={startDate} endDate={endDate} selectedAssistant={selectedAssistant} />
        <br />
        <div className="py-3 text-left text-lg">Email Messages</div>
        <Messages startDate={startDate} endDate={endDate} selectedAssistant={selectedAssistant} msgType="Email" />
        <br />
        <div className="py-3 text-left text-lg">SMS Messages</div>
        <Messages startDate={startDate} endDate={endDate} selectedAssistant={selectedAssistant} msgType="SMS" />
        <br />
        <div className="py-3 text-left text-lg">WhatsApp Messages</div>
        <Messages startDate={startDate} endDate={endDate} selectedAssistant={selectedAssistant} msgType="WhatsApp" />
      </div>
    </div>
  );
};

export default Dashboard;
